export const WAGE_PASS_THROUGH_LABEL = "Provider wages";
export const WAGE_PASS_THROUGH_DETAIL =
  "Approved shift wages, billed as paid to providers";
export const SAILE_CHARGES_LABEL = "Saile charges";
export const WAGE_PASS_THROUGH_OFF_LABEL = "Paid directly by the unit";
export const WAGE_PASS_THROUGH_OFF_SUMMARY_LABEL = "Paid directly";
export const WAGE_PASS_THROUGH_SWITCH_LABEL =
  "Bill provider wages on the invoice";
export const WAGE_PASS_THROUGH_ON_HELP =
  "Each invoice adds the approved shift wages as paid to providers, alongside the shift markup.";
export const WAGE_PASS_THROUGH_OFF_HELP =
  "The unit pays its providers directly. Only the shift markup is invoiced.";
export const WAGE_PASS_THROUGH_PLAN_LABEL = "Provider wages";
export const WAGE_PASS_THROUGH_REPORTS_NOTE =
  "Applies to every cycle not yet drafted, including the one in progress. Issued invoices keep their lines; usage reports show the current setting.";
export const WAGE_PASS_THROUGH_PLAN_ON =
  "On: billed on the invoice as paid to providers";
export const WAGE_PASS_THROUGH_PLAN_OFF =
  "Off: the unit pays providers directly";
export const WAGE_PASS_THROUGH_PLAN_CARD_ON =
  "Billed on the invoice as paid to providers";
export const ORG_WAGE_PASS_THROUGH_DETAIL =
  "Your providers' approved shift pay, billed as paid to them";
export const INVOICE_LINES_SUBTOTAL_LABEL = "Subtotal";
